module.exports = __webpack_public_path__ + "img/icon-empty-meeting.520b7a6a.png";